"use client";

import { useCallback, useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import type { ExchangeSessionResult } from "../types";
import { useExtendedConnection } from "./useExtendedConnection";

export function useExtendedSession(): ExchangeSessionResult {
  const extendedConnection = useExtendedConnection();

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const selectedAccount = useMemo(() => {
    const accts = extendedConnection.extendedAccounts;
    if (selectedAccountId != null) return accts.find((a) => a.id === selectedAccountId) ?? null;
    return accts[0] ?? null;
  }, [extendedConnection.extendedAccounts, selectedAccountId]);

  const setSelectedAccount = useCallback(
    (account: HubExchangeAccount | null) => setSelectedAccountId(account?.id ?? null),
    [],
  );

  return {
    connection: extendedConnection,
    sessionStatus: extendedConnection.sessionStatus,
    accounts: extendedConnection.extendedAccounts,
    selectedAccount,
    setSelectedAccount,
    handleSetupAction: () => {},
    isSettingUp: false,
    requiredWalletRole: null,
    requiredWalletAddress: extendedConnection.connectedAddress,
    exchangeAccountAddress: extendedConnection.connectedAddress,
    needsDeposit: false,
  };
}
